import(/* webpackMode: "eager", webpackExports: ["GuideArticlePageView"] */ "/vercel/path0/src/app/guides/_components/guide-article-page-view.tsx");
